import { Routes } from '@angular/router';
import { DashboardComponent } from './core/layout/pages/dashboard/dashboard.component';
import { AdvancedModeWizardComponent } from './core/advanced-mode-wizard/advanced-mode-wizard.component';
import { HomeComponent } from './core/home/home.component';
import { authGuard } from './core/auth/guards/auth.guard';


export const routes: Routes = [
   {
    path: 'advanced-mode',
    component: AdvancedModeWizardComponent,
    canActivate: [authGuard],
  },
  {
    path: 'dashboard',
    component: HomeComponent,
    canActivate: [authGuard],

  },
  { path: '**', redirectTo: 'auth', pathMatch: 'full' },
];
